import React, { useState } from 'react';

interface MonthlyData {
  classes: number;
  students: number;
}

interface TrainingStatisticsData {
  stt: string;
  content: string;
  isSubItem?: boolean;
  isTotal?: boolean;
  months: {
    [key: string]: MonthlyData;
  };
}

const RegionalTrainingStatisticsReport: React.FC = () => {
  const [selectedYear, setSelectedYear] = useState<string>('2025');
  const [selectedRegion, setSelectedRegion] = useState<string>('TSN');
  const [exportFormat, setExportFormat] = useState<string>('excel');

  const months = [
    'Tháng 01', 'Tháng 02', 'Tháng 03', 'Tháng 04', 'Tháng 05', 'Tháng 06',
    'Tháng 07', 'Tháng 08', 'Tháng 09', 'Tháng 10', 'Tháng 11', 'Tháng 12'
  ];

  const reportData: TrainingStatisticsData[] = [
    {
      stt: '1',
      content: 'ĐÀO TẠO BAN ĐẦU - NHÂN VIÊN MỚI',
      months: {
        'Tháng 01': { classes: 31, students: 566 },
        'Tháng 02': { classes: 14, students: 258 },
        'Tháng 03': { classes: 37, students: 783 },
        'Tháng 04': { classes: 20, students: 706 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '1.1.1',
      content: 'Kiến thức chung về HKDD',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 11, students: 367 },
        'Tháng 02': { classes: 7, students: 223 },
        'Tháng 03': { classes: 19, students: 423 },
        'Tháng 04': { classes: 13, students: 426 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '1.1.2',
      content: 'Chuyên môn nghiệp vụ',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 20, students: 199 },
        'Tháng 02': { classes: 7, students: 35 },
        'Tháng 03': { classes: 18, students: 360 },
        'Tháng 04': { classes: 7, students: 280 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '2',
      content: 'ĐÀO TẠO BAN ĐẦU - BỔ SUNG NĂNG ĐỊNH',
      months: {
        'Tháng 01': { classes: 30, students: 222 },
        'Tháng 02': { classes: 55, students: 442 },
        'Tháng 03': { classes: 52, students: 555 },
        'Tháng 04': { classes: 77, students: 595 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '2.2.1',
      content: 'Kiến thức chung về HKDD',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 6, students: 66 },
        'Tháng 02': { classes: 2, students: 24 },
        'Tháng 03': { classes: 2, students: 44 },
        'Tháng 04': { classes: 3, students: 48 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '2.2.2',
      content: 'Chuyên môn nghiệp vụ',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 18, students: 77 },
        'Tháng 02': { classes: 48, students: 352 },
        'Tháng 03': { classes: 46, students: 465 },
        'Tháng 04': { classes: 74, students: 547 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '2.2.3',
      content: 'Chương trình đào tạo bổ sung',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 6, students: 79 },
        'Tháng 02': { classes: 5, students: 66 },
        'Tháng 03': { classes: 4, students: 46 },
        'Tháng 04': { classes: 0, students: 0 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '3',
      content: 'ĐÀO TẠO ĐỊNH KỲ',
      months: {
        'Tháng 01': { classes: 31, students: 452 },
        'Tháng 02': { classes: 44, students: 632 },
        'Tháng 03': { classes: 32, students: 422 },
        'Tháng 04': { classes: 46, students: 703 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '3.3.1',
      content: 'Kiến thức chung về HKDD',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 19, students: 332 },
        'Tháng 02': { classes: 28, students: 467 },
        'Tháng 03': { classes: 19, students: 329 },
        'Tháng 04': { classes: 29, students: 597 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '3.3.2',
      content: 'Chuyên môn nghiệp vụ',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 9, students: 93 },
        'Tháng 02': { classes: 11, students: 82 },
        'Tháng 03': { classes: 13, students: 93 },
        'Tháng 04': { classes: 11, students: 88 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '3.3.3',
      content: 'Chương trình đào tạo bổ sung',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 3, students: 27 },
        'Tháng 02': { classes: 5, students: 83 },
        'Tháng 03': { classes: 0, students: 0 },
        'Tháng 04': { classes: 6, students: 18 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '4',
      content: 'ĐÀO TẠO PHỤC HỒI',
      months: {
        'Tháng 01': { classes: 7, students: 21 },
        'Tháng 02': { classes: 7, students: 7 },
        'Tháng 03': { classes: 7, students: 7 },
        'Tháng 04': { classes: 7, students: 7 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '4.4.1',
      content: 'Kiến thức chung về HKDD',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 6, students: 18 },
        'Tháng 02': { classes: 6, students: 6 },
        'Tháng 03': { classes: 6, students: 6 },
        'Tháng 04': { classes: 6, students: 6 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '4.4.2',
      content: 'Chuyên môn nghiệp vụ',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 1, students: 3 },
        'Tháng 02': { classes: 1, students: 1 },
        'Tháng 03': { classes: 1, students: 1 },
        'Tháng 04': { classes: 1, students: 1 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '5',
      content: 'ĐÀO TẠO BỒI DƯỠNG KIẾN THỨC',
      months: {
        'Tháng 01': { classes: 11, students: 218 },
        'Tháng 02': { classes: 2, students: 40 },
        'Tháng 03': { classes: 14, students: 209 },
        'Tháng 04': { classes: 13, students: 172 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '6',
      content: 'ĐÀO TẠO KHÁC',
      months: {
        'Tháng 01': { classes: 17, students: 116 },
        'Tháng 02': { classes: 11, students: 129 },
        'Tháng 03': { classes: 10, students: 242 },
        'Tháng 04': { classes: 30, students: 582 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '6.6.1',
      content: 'Đào tạo theo CTDT các Hãng HK',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 8, students: 107 },
        'Tháng 02': { classes: 11, students: 129 },
        'Tháng 03': { classes: 10, students: 242 },
        'Tháng 04': { classes: 30, students: 582 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '6.6.2',
      content: 'Đào tạo nhân lãi',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 9, students: 9 },
        'Tháng 02': { classes: 0, students: 0 },
        'Tháng 03': { classes: 0, students: 0 },
        'Tháng 04': { classes: 0, students: 0 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    },
    {
      stt: '6.6.3',
      content: '',
      isSubItem: true,
      months: {
        'Tháng 01': { classes: 0, students: 0 },
        'Tháng 02': { classes: 0, students: 0 },
        'Tháng 03': { classes: 0, students: 0 },
        'Tháng 04': { classes: 0, students: 0 },
        'Tháng 05': { classes: 0, students: 0 },
        'Tháng 06': { classes: 0, students: 0 },
        'Tháng 07': { classes: 0, students: 0 },
        'Tháng 08': { classes: 0, students: 0 },
        'Tháng 09': { classes: 0, students: 0 },
        'Tháng 10': { classes: 0, students: 0 },
        'Tháng 11': { classes: 0, students: 0 },
        'Tháng 12': { classes: 0, students: 0 }
      }
    }
  ];

  // Calculate totals
  const calculateTotals = (): TrainingStatisticsData => {
    const totals: TrainingStatisticsData = {
      stt: '',
      content: 'TỔNG A',
      isTotal: true,
      months: {}
    };

    months.forEach(month => {
      let totalClasses = 0;
      let totalStudents = 0;
      
      reportData.forEach(item => {
        if (!item.isSubItem && !item.isTotal) {
          totalClasses += item.months[month].classes;
          totalStudents += item.months[month].students;
        }
      });
      
      totals.months[month] = { classes: totalClasses, students: totalStudents };
    });

    return totals;
  };

  const totals = calculateTotals();
  const allData = [...reportData, totals];

  const handleExport = () => {
    console.log(`Exporting regional statistics in ${exportFormat} format`);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            THỐNG KÊ SỐ LIỆU ĐÀO TẠO KHU VỰC {selectedRegion}- {selectedYear}
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            Báo cáo chi tiết số liệu đào tạo theo từng tháng trong năm
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <select 
            value={selectedRegion}
            onChange={(e) => setSelectedRegion(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm"
          >
            <option value="TSN">TSN</option>
            <option value="TTB">TTB</option>
            <option value="TNB">TNB</option>
          </select>
          <select 
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm"
          >
            <option value="2025">2025</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
          </select>
          <select 
            value={exportFormat}
            onChange={(e) => setExportFormat(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm"
          >
            <option value="excel">Excel</option>
            <option value="pdf">PDF</option>
            <option value="csv">CSV</option>
          </select>
          <button 
            onClick={handleExport}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            Xuất báo cáo
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-3">Tổng số lớp</h3>
          <div className="space-y-2">
            <p className="text-2xl font-bold text-blue-600">
              {Object.values(totals.months).reduce((sum, month) => sum + month.classes, 0)}
            </p>
            <p className="text-sm text-gray-600">Tổng số lớp đào tạo</p>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-3">Tổng học sinh</h3>
          <div className="space-y-2">
            <p className="text-2xl font-bold text-green-600">
              {Object.values(totals.months).reduce((sum, month) => sum + month.students, 0)}
            </p>
            <p className="text-sm text-gray-600">Tổng số học sinh</p>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-3">Hoạt động nhất</h3>
          <div className="space-y-2">
            <p className="text-sm font-medium text-gray-900">Tháng 04</p>
            <p className="text-sm text-gray-600">193 lớp, 2,765 học sinh</p>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-3">Khu vực</h3>
          <div className="space-y-2">
            <p className="text-lg font-bold text-purple-600">{selectedRegion}</p>
            <p className="text-sm text-gray-600">Khu vực đào tạo</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse">
            {/* Header */}
            <thead className="bg-blue-50">
              <tr className="border-b border-gray-300">
                <th className="px-3 py-3 text-center text-xs font-medium text-gray-700 border border-gray-300 bg-blue-100">
                  STT
                </th>
                <th className="px-3 py-3 text-center text-xs font-medium text-gray-700 border border-gray-300 bg-blue-100">
                  NỘI DUNG
                </th>
                {months.map((month, index) => (
                  <th key={month} colSpan={2} className="px-3 py-3 text-center text-xs font-medium text-gray-700 border border-gray-300">
                    {month}
                  </th>
                ))}
              </tr>
              <tr className="border-b border-gray-300">
                <th className="px-2 py-2 text-center text-xs font-medium text-gray-700 border border-gray-300"></th>
                <th className="px-2 py-2 text-center text-xs font-medium text-gray-700 border border-gray-300"></th>
                {months.map((month, index) => (
                  <React.Fragment key={month}>
                    <th className="px-2 py-2 text-center text-xs font-medium text-gray-700 border border-gray-300">Số lớp</th>
                    <th className="px-2 py-2 text-center text-xs font-medium text-gray-700 border border-gray-300">SL HV</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            
            {/* Table Body */}
            <tbody className="bg-white">
              {allData.map((row, index) => (
                <tr key={index} className={`${
                  row.isTotal ? 'bg-red-50 font-bold text-red-700' : 
                  row.isSubItem ? 'bg-gray-50' : 'hover:bg-gray-50'
                }`}>
                  <td className={`px-3 py-2 text-center text-sm border border-gray-300 ${
                    row.isTotal ? 'bg-red-100 font-bold' : ''
                  }`}>
                    {row.stt}
                  </td>
                  <td className={`px-3 py-2 text-left text-sm border border-gray-300 ${
                    row.isSubItem ? 'pl-8' : ''
                  } ${row.isTotal ? 'bg-red-100 font-bold' : ''}`}>
                    {row.content}
                  </td>
                  {months.map((month, monthIndex) => (
                    <React.Fragment key={month}>
                      <td className={`px-2 py-2 text-center text-sm border border-gray-300 ${
                        row.isTotal ? 'bg-red-100 font-bold' : ''
                      }`}>
                        {row.months[month].classes || ''}
                      </td>
                      <td className={`px-2 py-2 text-center text-sm border border-gray-300 ${
                        row.isTotal ? 'bg-red-100 font-bold' : ''
                      }`}>
                        {row.months[month].students || ''}
                      </td>
                    </React.Fragment>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Note */}
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <p className="text-sm text-yellow-800">
          <span className="font-medium">Lưu ý:</span> Ước thực hiện trong báo cáo tháng
        </p>
      </div>
    </div>
  );
};

export default RegionalTrainingStatisticsReport; 